import { useApplication } from 'src/context/ApplicationContext';
import { useStepTranslations } from 'src/hooks/useClientTranslations';
import { Proof } from 'src/types/api';

export const useSubmissionValidation = ({
  isTOSChecked,
  hasSubmitted,
  proofs
}: {
  isTOSChecked: boolean;
  hasSubmitted: boolean;
  proofs: Proof[];
}) => {
  const { tStep } = useStepTranslations();
  const { connectedPayroll, bankLinking } = useApplication();

  let disabledText = '';
  if (proofs.some((proof) => Boolean(proof.jobs_error?.length))) {
    disabledText = tStep('submit.errorsInProofs');
  } else if (
    !connectedPayroll.accountsConnected?.length &&
    !proofs.length &&
    !bankLinking.accountsConnected?.length
  ) {
    disabledText = tStep('submit.hasNoConnectedPayrollAndProofs');
  } else if (!isTOSChecked) {
    disabledText = tStep('submit.tosNotChecked');
  }

  return {
    disabledText,
    isSubmittable:
      !bankLinking.isLoadingAccounts &&
      !bankLinking.isDisconnectingAccount &&
      !connectedPayroll.isLoadingAccounts &&
      !connectedPayroll.isDisconnectingAccount &&
      !hasSubmitted &&
      !disabledText
  };
};
